import React from "react";
import { motion, Variants } from "framer-motion";
import { useTranslation } from "react-i18next";
import Section from "../components/Section";
import cls from "./WarSection.module.css";
import warImg from '../assets/war_img.png'
import warBg from '../assets/war-bg.png'

interface WarSectionProps {
  isActive: boolean;
}

const containerVariants: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.15, delayChildren: 0.2 },
  },
};

const itemVariants: Variants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

const awardsContainer: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1, delayChildren: 0.6 },
  },
};

const awardItemVariants: Variants = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: { opacity: 1, scale: 1, transition: { type: "spring", damping: 15 } },
};

const WarSection: React.FC<WarSectionProps> = ({ isActive }) => {
  const { t } = useTranslation();

  // Массив наград для рендера
  const awardsList = [
    { key: "lenin1", year: "1940" },
    { key: "stalin", year: "1942" },
    { key: "war", year: "1945" },
    { key: "lenin2", year: "1945" },
    { key: "lenin3", year: "1957" },
    { key: "lenin_p", year: "1958" },
    { key: "order4", year: "1963" },
  ];

  return (
    <Section isActive={isActive}>
      <div className={cls.spiritSection}>
        
        <motion.img 
          src={warBg} 
          alt="" 
          className={cls.absoluteImg}
          initial={{ opacity: 0, x: 50 }}
          animate={isActive ? { opacity: 1, x: 0 } : { opacity: 0, x: 50 }}
          transition={{ duration: 1.5, ease: "easeOut" }}
        />

        <motion.div 
          className={cls.container}
          variants={containerVariants}
          initial="hidden"
          animate={isActive ? "visible" : "hidden"}
        >
          <motion.h2 className={cls.title} variants={itemVariants}>
            {t('war.title')}
          </motion.h2>

          <div className={cls.descBlock}>
            <motion.img 
              className={cls.imgBlock} 
              src={warImg} 
              alt="War context"
              variants={itemVariants}
            />

            <div className={cls.description}>
              <motion.p variants={itemVariants}>{t('war.desc1')}</motion.p>
              <motion.p variants={itemVariants}>{t('war.desc2')}</motion.p>
              <motion.p variants={itemVariants}>{t('war.desc3')}</motion.p>
            </div>
          </div>

          <motion.div className={cls.awardsBlock} variants={awardsContainer}>
            <h3 className={cls.awardsTitle}>{t('war.awardsTitle')}</h3>

            <div className={cls.awardsItemsBlock}>
              {awardsList.map((item) => (
                <motion.div 
                  key={item.key} 
                  className={cls.awardsItem} 
                  variants={awardItemVariants}
                >
                  <p className={cls.awardsItemTitle}>
                    {t(`war.awards.${item.key}`)}
                  </p>
                  <div className={cls.awardsItemYear}>
                    {item.year} {t('war.yearSuffix')}
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>

        </motion.div>
      </div>
    </Section>
  );
};

export default WarSection;